App.directive('removeOrphans', ['$compile', function($compile) { 
    return {
        restrict: 'AEC',
        scope: true,
        link: function(scope, elm) {
            // elm[0].innerHTML = elm[0].innerHTML.replace(' i ', ' i&nbsp;');

            var tags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li'];

            for (var x = 0; x < tags.length; x++) {
                var el = $(elm[0]).find(tags[x]);
                for (var y = 0; y < el.length; y++) {
                    el[y].innerHTML = el[y].innerHTML.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;");
                    $compile(el[y])(scope);
                }
            }

        }
    }
}]);